import { chatApi } from '../api/client'
import type { ChatConversation, DeliveredItem } from '../api/types'

const WINDOW_MS = 5_000
const CHUNK = 50

const pending = new Map<number, number>()
let timer: ReturnType<typeof setTimeout> | null = null

function chunk(items: DeliveredItem[]): DeliveredItem[][] {
  const out: DeliveredItem[][] = []
  for (let index = 0; index < items.length; index += CHUNK) {
    out.push(items.slice(index, index + CHUNK))
  }
  return out
}

export async function flushDelivered(): Promise<void> {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
  if (pending.size === 0) return

  const items = Array.from(pending, ([conversationId, lastMessageId]) => ({ conversationId, lastMessageId }))
  pending.clear()

  for (const batch of chunk(items)) {
    try {
      await chatApi.markDelivered(batch)
    } catch {
      return
    }
  }
}

export function queueDelivered(conversationId: number, lastMessageId: number): void {
  const current = pending.get(conversationId)
  if (current != null && current >= lastMessageId) return
  pending.set(conversationId, lastMessageId)
  if (timer) return
  timer = setTimeout(() => {
    timer = null
    void flushDelivered()
  }, WINDOW_MS)
}

export function flushDeliveredForList(conversations: ChatConversation[]): void {
  for (const conversation of conversations) {
    if (conversation.lastMessageId == null) continue
    if (
      conversation.myLastDeliveredMessageId != null &&
      conversation.myLastDeliveredMessageId >= conversation.lastMessageId
    ) {
      continue
    }
    const current = pending.get(conversation.id)
    if (current != null && current >= conversation.lastMessageId) continue
    pending.set(conversation.id, conversation.lastMessageId)
  }
  void flushDelivered()
}

export function clearDeliveredQueue(): void {
  pending.clear()
  if (timer) clearTimeout(timer)
  timer = null
}
